"use strict";
/**
 * @module "ethpm/storage/ipfs"
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpfsService = void 0;
const url_1 = require("url");
const t = __importStar(require("io-ts"));
const config = __importStar(require("../../config"));
const hash_1 = __importDefault(require("./hash"));
const IPFS = require('ipfs-http-client');
class IpfsService {
    constructor(options) {
        this.host = options.host;
        this.port = options.port.toString();
        this.protocol = options.protocol;
        this.ipfs = new IPFS({
            host: this.host,
            port: this.port,
            protocol: this.protocol,
        });
    }
    write(content) {
        return __awaiter(this, void 0, void 0, function* () {
            const buffer = this.ipfs.types.Buffer.from(content);
            const [{ hash }] = yield this.ipfs.add(buffer);
            return new url_1.URL(`ipfs://${hash}`);
        });
    }
    read(uri) {
        return __awaiter(this, void 0, void 0, function* () {
            const hash = uri.host;
            const buffer = yield this.ipfs.cat(hash);
            return buffer.toString();
        });
    }
    hash(content) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield hash_1.default(content);
        });
    }
    predictUri(content) {
        return __awaiter(this, void 0, void 0, function* () {
            const hash = yield this.hash(content);
            return new url_1.URL(`ipfs://${hash}`);
        });
    }
}
exports.IpfsService = IpfsService;
class IpfsConnector extends config.Connector {
    constructor() {
        super(...arguments);
        this.optionsType = t.interface({
            ipfs: t.interface({
                host: t.string,
                port: t.union([t.number, t.string]),
                protocol: t.string,
            }),
        });
    }
    /**
     * Construct IpfsService and load with specified contents
     */
    init(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const service = new IpfsService(options.ipfs);
            return service;
        });
    }
}
exports.default = IpfsConnector;
